import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class HOME_TRUST_REQUEST_FOR_FUNDS_Mapper extends BaseFormMapper<HOME_TRUST_REQUEST_FOR_FUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: HOME_TRUST_REQUEST_FOR_FUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as HOME_TRUST_REQUEST_FOR_FUNDS);

		return _formData;
	}

	MapValues(): Partial<HOME_TRUST_REQUEST_FOR_FUNDS> {
		return {};
	}
}

const Mappings: HOME_TRUST_REQUEST_FOR_FUNDS = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page1[0]",
	signatureSolicitor: 'topmostSubform[0].Page1[0].SIGNATURE_SOLICITOR[0]',
	accountName: 'topmostSubform[0].Page1[0].TRUST_ACCOUNT_NAME[0]',
	accountNumber: 'topmostSubform[0].Page1[0].TRUST_ACCOUNT[0]',
	bankTransitNumber: 'topmostSubform[0].Page1[0].TRUST_BRANCH[0]',
	bankAddress: 'topmostSubform[0].Page1[0].TRUST_IF_ADDRESS[0]',
	bank: 'topmostSubform[0].Page1[0].TRUST_IF[0]',
	deliveryMethod: 'topmostSubform[0].Page1[0].DELIVERY_METHOD[0]',
	deliveryDateYear: 'topmostSubform[0].Page1[0].DELIVERY_DATE_YEAR_YY[0]',
	deliveryDateMonth: 'topmostSubform[0].Page1[0].DELIVERY_DATE_MONTH[0]',
	deliveryDateDay: 'topmostSubform[0].Page1[0].DELIVERY_DATE_DAY[0]',
	pickUpAt: 'topmostSubform[0].Page1[0].PICKUP_AM_PM[0]',
	pickUpDateYear: 'topmostSubform[0].Page1[0].PICKUP_DATE_YEAR_YY[0]',
	pickUpDateMonth: 'topmostSubform[0].Page1[0].PICKUP_DATE_MONTH[0]',
	pickUpDateDay: 'topmostSubform[0].Page1[0].PICKUP_DATE_DAY[0]',
	elvAmount: 'topmostSubform[0].Page1[0].ELV_AMOUNT[0]',
	requestForFundsYear: 'topmostSubform[0].Page1[0].RFF_DATE_YEAR_YY[0]',
	requestForFundsMonth: 'topmostSubform[0].Page1[0].RFF_DATE_MONTH[0]',
	requestForFundsDay: 'topmostSubform[0].Page1[0].RFF_DATE_DAY[0]',
	secondMortgagePaymentAmount:
		'topmostSubform[0].Page1[0].SECOND_MORTGAGE_PAY_AMOUNT[0]',
	secondMortgagePrincipalAmount:
		'topmostSubform[0].Page1[0].SECOND_MORTGAGE_PRINC_AMOUNT[0]',
	secondMortgageeAddress:
		'topmostSubform[0].Page1[0].SECOND_MORTGAGE_ADDRESS[0]',
	secondMortgageeName: 'topmostSubform[0].Page1[0].SECOND_MORTGAGE_NAME[0]',
	agentAddress:
		'topmostSubform[0].Page1[0].FIRE_INSURANCE_POLICY_AGENT_ADDRESS[0]',
	agentName: 'topmostSubform[0].Page1[0].FIRE_INSURANCE_POLICY_AGENT_NAME[0]',
	fireInsuranceCompanyExpireDate:
		'topmostSubform[0].Page1[0].FIRE_INSURANCE_EXPIRE_DATE[0]',
	fireInsuranceCompanyInsuranceAmount:
		'topmostSubform[0].Page1[0].FIRE_INSURANCE_AMOUNT[0]',
	fireInsuranceCompanyPolicyNumber:
		'topmostSubform[0].Page1[0].FIRE_INSURANCE_POLICY_NUM[0]',
	fireInsuranceCompany: 'topmostSubform[0].Page1[0].FIRE_INSURANCE_COMPANY[0]',
	taxRollNumber: 'topmostSubform[0].Page1[0].TAX_ROLL_NUMBER[0]',
	taxBillYear: 'topmostSubform[0].Page1[0].DATE_TAX_BILL_YEAR_YY[0]',
	titleChargorsYear: 'topmostSubform[0].Page1[0].TITLE_CHARGOR_DATE_YEAR_YY[0]',
	titleChargorsMonth: 'topmostSubform[0].Page1[0].TITLE_CHARGOR_DATE_MONTH[0]',
	titleChargorsDay: 'topmostSubform[0].Page1[0].TITLE_CHARGOR_DATE_DAY[0]',
	restrictions: 'topmostSubform[0].Page1[0].EASEMENTS_ALL[0]',
	additionalCovenantor: 'topmostSubform[0].Page1[0].ADD_COVENANTOR[0]',
	legalDescription: 'topmostSubform[0].Page1[0].LEGAL_DESC_RFF_RF_NOPID[0]',
	civicAddress: 'topmostSubform[0].Page1[0].ADRESSE_PROPRIETE[0]',
	chargor: 'topmostSubform[0].Page1[0].COB_LINE_HAS_ENTERED[0]',
	from: 'topmostSubform[0].Page1[0].NOTAIRE_NOM_COMPLET[0]',

	mortgageDate: 'topmostSubform[0].Page1[0].DATE_OF_MORTGAGE[0]',
	// "42":"topmostSubform[0].Page1[0].BARCODE_FINAL_REPORT[0]",
	// "43":"topmostSubform[0].Page1[0].FAX_NO[0]",
	mortgageNo: 'topmostSubform[0].Page1[0].MORTGAGE_NUMBER[0]',
};

export interface HOME_TRUST_REQUEST_FOR_FUNDS {
	from: string;
	mortgageDate: string;
	mortgageNo: string;
	chargor: string;
	civicAddress: string;
	legalDescription: string;
	additionalCovenantor: string;
	restrictions: string;

	titleChargorsDay: string;
	titleChargorsMonth: string;
	titleChargorsYear: string;

	taxBillYear: string;
	taxRollNumber: string;

	fireInsuranceCompany: string;
	fireInsuranceCompanyPolicyNumber: string;
	fireInsuranceCompanyInsuranceAmount: string;
	fireInsuranceCompanyExpireDate: string;

	agentName: string;
	agentAddress: string;

	secondMortgageeName: string;
	secondMortgageeAddress: string;
	secondMortgagePrincipalAmount: string;
	secondMortgagePaymentAmount: string;

	requestForFundsDay: string;
	requestForFundsMonth: string;
	requestForFundsYear: string;
	elvAmount: string;

	deliveryMethod: string;
	pickUpDateDay: string;
	pickUpDateMonth: string;
	pickUpDateYear: string;
	pickUpAt: string;

	deliveryDateDay: string;
	deliveryDateMonth: string;
	deliveryDateYear: string;

	bank: string;
	bankAddress: string;
	bankTransitNumber: string;
	accountNumber: string;
	accountName: string;

	signatureSolicitor: string;
}
